import { REVIEWS_WIDGET_NAMES } from "@/constants/widget-names";
import { defineModule } from "@modules/dynamic_import/utils/defineModule";

export const AverageReviewsWidgetDefinition = defineModule({
    name: REVIEWS_WIDGET_NAMES.AVERAGE_REVIEWS_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "AverageReviewsWidget" */ "./widgets/average_reviews_widget/AverageReviewsWidget"
        ),
});

export const ListingAverageReviewsWidgetDefinition = defineModule({
    name: REVIEWS_WIDGET_NAMES.LISTING_AVERAGE_REVIEWS_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "ListingAverageReviewsWidget" */ "./widgets/listing_average_reviews_widget/ListingAverageReviewsWidget"
        ),
});

export const ProductReviewsMiniSliderWidgetDefinition = defineModule({
    name: REVIEWS_WIDGET_NAMES.PRODUCT_REVIEWS_MINI_SLIDER_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "ProductReviewsMiniSliderWidget" */ "./widgets/product_reviews_mini_slider_widget/ProductReviewsMiniSliderWidget"
        ),
});

export const QuestionsFormModalWidgetDefinition = defineModule({
    name: REVIEWS_WIDGET_NAMES.QUESTIONS_FORM_MODAL_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "QuestionsFormModalWidget" */ "./widgets/questions_form_modal_widget/QuestionsFormModalWidget"
        ),
});

export const ReviewsFormModalWidgetDefinition = defineModule({
    name: REVIEWS_WIDGET_NAMES.REVIEWS_FORM_MODAL_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "ReviewsFormModalWidget" */ "./widgets/review_form_modal_widget/ReviewsFormModalWidget"
        ),
});

export const ReviewsDrawerWidgetDefinition = defineModule({
    name: REVIEWS_WIDGET_NAMES.REVIEWS_DRAWER_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "ReviewsDrawerWidget" */ "./widgets/reviews_drawer_widget/ReviewsDrawerWidget"
        ),
});

export const ReviewsGalleryWidgetDefinition = defineModule({
    name: REVIEWS_WIDGET_NAMES.REVIEWS_GALLERY_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "ReviewsGalleryWidget" */ "./widgets/reviews_gallery_widget/ReviewsGalleryWidget"
        ),
});

export const ReviewsPageWidgetDefinition = defineModule({
    name: REVIEWS_WIDGET_NAMES.REVIEWS_PAGE_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "ReviewsPageWidget" */ "./widgets/reviews_page_widget/ReviewsPageWidget"
        ),
});

export const ReviewsProductPageWidgetDefinition = defineModule({
    name: REVIEWS_WIDGET_NAMES.REVIEWS_PRODUCT_PAGE_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "ReviewsProductPageWidget" */ "./widgets/reviews_product_page_widget/ReviewsProductPageWidget"
        ),
});

export const ReviewsSliderWidgetDefinition = defineModule({
    name: REVIEWS_WIDGET_NAMES.REVIEWS_SLIDER_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "ReviewsSliderWidget" */ "./widgets/reviews_slider_widget/ReviewsSliderWidget"
        ),
});

export const LeaveReviewPageWidgetDefinition = defineModule({
    name: REVIEWS_WIDGET_NAMES.LEAVE_REVIEW_PAGE_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "LeaveReviewPageWidget" */ "./widgets/leave_review_page_widget/LeaveReviewPageWidget"
        ),
});

export const ReviewsWidgetDefinition = defineModule({
    name: REVIEWS_WIDGET_NAMES.REVIEWS_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "ReviewsWidget" */ "./widgets/reviews_widget/ReviewsWidget"
        ),
});

export const ReviewsListWidgetDefinition = defineModule({
    name: REVIEWS_WIDGET_NAMES.REVIEWS_LIST_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "ReviewsListWidget" */ "./widgets/reviews_list_widget/ReviewsListWidget"
        ),
});

export const QuestionsListWidgetDefinition = defineModule({
    name: REVIEWS_WIDGET_NAMES.QUESTIONS_LIST_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "QuestionsListWidget" */ "./widgets/questions_list_widget/QuestionsListWidget"
        ),
});

export const ReviewsListHeaderWidgetDefinition = defineModule({
    name: REVIEWS_WIDGET_NAMES.REVIEWS_LIST_HEADER_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "ReviewsListHeaderWidget" */ "./widgets/reviews_list_header_widget/ReviewsListHeaderWidget"
        ),
});

export const ReviewsTrustBadgeWidgetDefinition = defineModule({
    name: REVIEWS_WIDGET_NAMES.REVIEWS_TRUST_BADGE_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "ReviewsTrustBadgeWidget" */ "./widgets/reviews_trust_badge_widget/ReviewsTrustBadgeWidget"
        ),
});

export const LeaveReviewButtonWidgetDefinition = defineModule({
    name: REVIEWS_WIDGET_NAMES.LEAVE_REVIEW_BUTTON_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "LeaveReviewButtonWidget" */ "./widgets/leave_review_button_widget/LeaveReviewButtonWidget"
        ),
});
